/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import React from "react";
import {Avatar, Layout, Menu, Space, Tooltip} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {logout} from "../core/auth/authentication";
import {useAppSelector} from "../store";
import {Link} from "react-router-dom";
import {IconSet} from "./icons";
import {Timer} from "./timer";

export default function Header(props: any) {
    const userInfo = useAppSelector(state => state.auth.userInfo);
    const username = userInfo ? (userInfo['username'] ? userInfo['username'] : "") : ""

    return (
        <Layout.Header className='header'
                       style={{height: '48px', lineHeight: '48px', padding: 0, borderBottom: '1px solid #f0f0f0'}}>
            <Space align='end' size={18} style={{float: 'right', paddingRight: 18}}>
                <Menu
                    style={{minWidth:250, justifyContent:'flex-end'}}
                    mode={'horizontal'}
                    selectable={false}
                    items={[
                        {key: "Timer", label: <Timer/>},
                        {
                            key: "avatar", label: <><Avatar><UserOutlined/></Avatar>&nbsp;{username}</>,
                            children: [
                                {
                                    key: "logout",
                                    danger: true,
                                    onClick: () => logout(),
                                    icon: <IconSet type='logout'/>,
                                    label: 'Logout',
                                },
                                {
                                    key: "settings",
                                    icon: <IconSet type='settings'/>,
                                    label: <Link to={'/settings'}>Einstellungen</Link>
                                }
                            ]
                        }
                    ]}
                />
            </Space>
            <h1 style={{float: 'left', paddingLeft: 18, margin: 0, fontSize: 24}}>[ MPExpert ]</h1>
        </Layout.Header>
    );
}